<template>
  <v-text-field
    class="none-pointer-events"
    density="compact"
    :variant="variant"
    hide-details="auto"
    v-model="dateStr"
    :label="label"
    prepend-icon="mdi-calendar"
    :clearable="true"
    @click:clear="this.$refs.datePickerRef.clearValue()"
    @mousedown="this.$refs.datePickerRef.openMenu()"
    readonly
  ></v-text-field>
  <Datepicker 
    v-model="date" 
    ref="datePickerRef" 
    @update:model-value="save()" 
    locale="ja" 
    :select-text="$t('common.action.select')"
    :cancel-text="$t('common.action.cancel')"
    :enable-time-picker="false"
    :preview-format="format"
    position="left"
    :auto-position="false"
    :teleport="teleport"
    week-start="0"
    >
    <template #trigger>
    </template>
  </Datepicker>

</template>

<script>
import utils from '@/utils'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  components: {Datepicker},
  props: {
    modelValue: String,
    label: String,
    // 入力欄の見た目。既定は従来どおり underlined。周りが outlined の画面では合わせる（良品計画の棚卸・棚卸日登録）
    variant: { type: String, default: "underlined" },
    // カレンダーを出す先。ダイアログの中で使うと枠で切れるので "body" を渡す
    teleport: { type: String, default: undefined },
  },
  data: () => ({
    date: "",
    datePickerRef: "",
  }),
  
  // 親が v-model の値を変えたとき（初期値・クリア・前回の条件の復元など）にカレンダー側へ反映する。
  // それまでは setDate で入れた値しか表示されず、v-model に入っている初期値が欄に出なかった（2026-11-02）
  watch: {
    modelValue: {
      immediate: true,
      handler(v) {
        if ((v ?? "") === this.dateStr) return;
        const m = /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/.exec(v ?? "");
        this.date = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : "";
      },
    },
  },

  computed: {
    dateStr() {
      if(!(this.date instanceof Date)) return ""
      return utils.getCalendarStr(this.date);
    },
  },
  methods: {
    clear() {
      this.$refs.datePickerRef.clearValue()
    },
    //変更を検知 > inputのemitを更新する値と一緒に流すと親のv-modelのやつが変わる
    save() {
      this.$emit("update:modelValue", this.dateStr);
    },

    format: (date) => {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${year}-${month}-${day}`;
    },
    setDate(d) {
      this.date = d;
      this.save();
    },
  },
};
</script>

<style>
  /* .none-pointer-events{
    pointer-events: none;
  } */
</style>
